<script setup>
import { ref, onMounted } from 'vue';
import AgenteIaAPI from 'dashboard/api/agenteIa';

// Conta com o agente configurado pelo painel do motor: a tela fica somente leitura (o servidor tambem recusa a escrita).
// O aviso aparece uma vez so, no AgenteIaLayout.
const operado = ref(false);

onMounted(async () => {
  try {
    operado.value =
      (await AgenteIaAPI.status()).data.vinculo?.operado_externamente === true;
  } catch (e) {
    operado.value = false;
  }
});
</script>

<template>
  <fieldset :disabled="operado" class="flex flex-col gap-6 min-w-0">
    <slot />
  </fieldset>
</template>
